import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check, X } from "lucide-react";

const COLORS = ["#C0392B", "#D97757", "#B26B00", "#2980B9", "#2A4D3E"];
const LABELS = ["Very weak", "Weak", "Fair", "Strong", "Very strong"];

export default function PasswordStrength({ password }) {
  const [result, setResult] = useState({ score: 0, issues: [], ok: false });

  useEffect(() => {
    if (!password) { setResult({ score: 0, issues: [], ok: false }); return; }
    const t = setTimeout(async () => {
      try { const { data } = await api.post("/auth/password-strength", { password }); setResult(data); }
      catch { /* offline fallback */ }
    }, 250);
    return () => clearTimeout(t);
  }, [password]);

  if (!password) return null;
  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="h-1 flex-1 rounded-full transition-colors"
            style={{ background: i < result.score ? COLORS[result.score] : "#E8E6E1" }} />
        ))}
      </div>
      <div className="flex items-center justify-between mt-1.5">
        <span className="text-[11px] font-medium" style={{ color: result.score >= 3 ? "#2A4D3E" : "#8E9992" }}>
          {LABELS[Math.max(0, result.score)]}
        </span>
        {result.ok && (
          <span className="text-[11px] text-[#2A4D3E] flex items-center gap-1"><Check size={11} /> Strong enough</span>
        )}
      </div>
      {result.issues.length > 0 && (
        <ul className="mt-1.5 space-y-0.5">
          {result.issues.map((i) => (
            <li key={i} className="text-[11px] text-[#8E9992] flex items-center gap-1"><X size={10} /> {i}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
